import script from "./FooterTechnopolis.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterTechnopolis.vue?vue&type=script&setup=true&lang=js"

import "./FooterTechnopolis.vue?vue&type=style&index=0&id=3eeebc30&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3eeebc30"]])

export default __exports__